// extracted by mini-css-extract-plugin
var _1 = "FloatingCard-module__container--xm_to";
var _2 = "FloatingCard-module__content--voH23";
var _3 = "FloatingCard-module__isLoading--_P3lN";
var _4 = "FloatingCard-module__safeHoverArea--JLr2N";
var _5 = "FloatingCard-module__spacePlaceholder--IgocZ";
export { _1 as "container", _2 as "content", _3 as "isLoading", _4 as "safeHoverArea", _5 as "spacePlaceholder" }
